<template>
  <div class="m-b-30 card card-1 draftResponse">
     <b-row class="m-b-20">
       <b-col cols="9">
         <h3>Draft Response Stats</h3>
         
       </b-col>
       <b-col cols="3">
         <b-form-select v-model="days" :options="options" @change="generateDraftResponseStats"></b-form-select>
       </b-col>
     </b-row>

     <b-row v-if="!processingRequest">
       <b-col md="4" sm="6" v-for="stats in draftResponseStats" v-bind:key="stats.designerName">
            <single-designer-draft-stats :stat="stats"/>
       </b-col>
     </b-row>
     <div class="text-center" v-else>
       <b-spinner variant="primary" label="Spinning"></b-spinner>
     </div>
  </div>
</template>

<script>
import DashboardService from '../../../services/dashboard.service';
const SingleDesignerDraftStats = () => import(/* webpackChunkName: "single-designer-draft-stats" */ "./single-designer-draft-stats");
  export default {
      data(){
        return {
          days: 30,
          options: [
            { value: 15, text: 'Last 15 Days' },
            { value: 30, text: 'Last 30 Days' },
            { value: 45, text: 'Last 45 Days' },
            { value: 60, text: 'Last 60 Days' },
            { value: 75, text: 'Last 75 Days' },
            { value: 90, text: 'Last 90 Days' },
          ],
          draftResponseStats: [],
          processingRequest: false
        }
      },
      mounted(){
        if(this.storeInState.id){
          this.generateDraftResponseStats()
        }
      },
      components: {SingleDesignerDraftStats},
      methods: {
        async generateDraftResponseStats(){
          try{
              this.processingRequest = true;
              const result = await DashboardService.generateDraftResponseStats(this.storeInState.id, this.days)
              this.draftResponseStats = result.data.stats
              this.processingRequest = false;

            }catch(errors){
              console.log(errors)
               this.processingRequest = false;
            }
        }
      },
      watch: {
        storeInState(newValue, oldValue){
            this.generateDraftResponseStats()
        }
      },
      computed:{
       storeInState(){
         return this.$store.state.ecommerceStore.store
       }
     },
  }
</script>

<style lang="scss" scoped>
  .draftResponse{
     padding: 30px;
  }
</style>